export const TRON = "tron";
export const TRON_SUPPORTED_WALLETS = ["trust-wallet", "walletConnect"];
